import { Link } from "react-router-dom";
import CookieSettings from "./CookieSettings";
import { Activity } from "lucide-react";
import { appVersionLabel } from "@/lib/appVersion";

// Custom pulse animation styles - similar to header
const footerStyles = `
  @keyframes enhanced-pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.8;
      transform: scale(1.08);
    }
  }
  
  .animate-enhanced-pulse {
    animation: enhanced-pulse 2s ease-in-out infinite;
  }
`;

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: footerStyles }} />
      <footer className="bg-gray-950 py-8 border-t border-gray-700">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
              <button 
                onClick={scrollToTop}
                className="text-2xl font-bold text-white flex items-center focus:outline-none hover:opacity-90 transition-opacity gap-1"
                aria-label="Back to top"
              >
                <Activity className="h-6 w-6 text-indigo-400 animate-enhanced-pulse" strokeWidth={1.5} />
                <span className="flex items-center">
                  skore<span className="text-indigo-300">.info</span>
                </span>
              </button>
              <p className="text-gray-300 text-sm mt-2">
                Watch sports without spoilers
              </p>
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-center">
              <Link to="/privacy" className="text-gray-300 hover:text-white text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-300 hover:text-white text-sm">
                Terms of Use
              </Link>
              <CookieSettings />
            </div>
          </div>
          <div className="mt-8 text-center text-gray-300 text-xs">
          © {new Date().getFullYear()} <a href="https://ginylil.com" target="_blank" rel="noopener noreferrer" className="text-indigo-300 hover:text-indigo-200">Ginylil S.L.</a> All rights reserved. <span className="whitespace-nowrap">{appVersionLabel}</span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
